const emailMapping = {
	'expedia': 'expedia',
	'despegar.com.ar': 'expedia',
	'e-domizil.com': 'expedia',
	'touricoholidays.com': 'expedia',
	'airbnb': 'airbnb',
	'homeaway.co.uk': 'homeaway',
	'tripadvisor.com': 'tripadvisor',
	'tuivillas.com': 'tui',
	'booking.com': 'booking.com',
	'direct': 'direct',
	'holidu.co.uk': 'holidu',
	'plumguide.com': 'plumguide',
	'hometogo.com': 'hometogo',
} as const;

const match = (text: string, patterns: typeof emailMapping) => {
	for (const [pattern, value] of Object.entries(patterns)) {
		if (text.includes(pattern)) {
			return value;
		}
	}
	return null;
};

export const getGroupFromSource = (source: string) => {
	return match(source, emailMapping) || 'unknown';
};
